import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { captureDemoParam } from "./pages/crm/meetingNotes/flow/demoSwitch";
import "./styles/tokens.css";
import "./styles.css";
import "./styles/crmUI.css";
import "./styles/crm-lead-inbox.css";
// 디자인 시스템 이식(_handoff) — Tailwind 지시자 + DS 토큰/모션.
// 마지막 CSS import 유지(DS 유틸리티가 동률 특이도에서 우선).
import "./styles/design-tokens.css";
// 휴대폰(≤640px) 전용 레이아웃 보정 — 인라인 그리드 !important 오버라이드를
// 위해 반드시 가장 마지막에 로드(주입 순서상 최후 → 동률 특이도에서 우선).
import "./styles/mobile.css";

// AI 회의록 시연 모드(`?mn_demo=1`)는 주소가 바뀌기 전에 잡아 둔다 — demoSwitch.ts 주석.
captureDemoParam();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Signal to the bundle-error watchdog in index.html that the app mounted.
(window as { __APP_READY?: boolean }).__APP_READY = true;

// PWA — 서비스워커(public/sw.js)는 production 빌드에서만 등록한다. 등록 코드는 여기 한 곳뿐(이중 등록 금지).
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn("[PWA] 서비스워커 등록 실패", err);
    });
  });
}
